import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * `when` = where the section top must sit in the viewport before reveal (0–1).
 *   0    → top of the viewport
 *   0.7  → 70% down (default) — near bottom, early reveal
 *   1    → bottom of the viewport (fires as soon as it enters)
 */
const defaults = {
  when: 0.7,
  once: true,
  className: "is-in-view",
};

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

function whenToStart(when) {
  if (when <= 0) {
    return "top top";
  }

  if (when >= 1) {
    return "top bottom";
  }

  return `top ${Math.round(when * 100)}%`;
}

function hasRequiredContent(section, require) {
  if (!require) {
    return true;
  }

  return Boolean(section.querySelector(require));
}

function revealSection(section, className) {
  if (section.classList.contains(className)) {
    return;
  }

  section.classList.add(className);
}

function initScrollRevealBlock(block) {
  const className = block.className ?? defaults.className;
  const start = whenToStart(block.when ?? defaults.when);
  const sections = document.querySelectorAll(block.selector);

  sections.forEach((section) => {
    if (!hasRequiredContent(section, block.require)) {
      return;
    }

    if (reducedMotion) {
      revealSection(section, className);
      return;
    }

    ScrollTrigger.create({
      trigger: section,
      start,
      once: block.once ?? defaults.once,
      onEnter: () => {
        revealSection(section, className);
      },
    });
  });
}

export function initScrollReveal(blocks) {
  blocks.forEach(initScrollRevealBlock);
}

const scrollRevealBlocks = [
  {
    selector: ".facts",
    require: ".facts__item",
  },
];

initScrollReveal(scrollRevealBlocks);

window.addEventListener(
  "load",
  () => {
    ScrollTrigger.refresh();
  },
  { once: true },
);
